import * as React from 'react';

import { makeStyles, Typography } from '@material-ui/core';

import { formatMoeda } from '../../../utils';

const useStyles = makeStyles((theme) => ({
  pendente: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    color: 'white',
    backgroundColor: '#f44336',
  },
  confirmado: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    color: 'white',
    backgroundColor: '#4caf50',
  },
}));

const ValorField = (props) => {
  const classes = useStyles();

  const valor = props ? props.record.valor : 0;
  const tipo = props ? props.record.tipo : 'Despesa';
  return (
    <Typography
      variant="subtitle1"
      // component="h2"
      // align="center"
      style={{
        color: tipo === 'Receita' ? '#4caf67' : '#f44336',
        fontWeight: 'bold',
      }}
    >
      {formatMoeda(valor)}
    </Typography>
  );
};

export default ValorField;
